(function($) {
	$(document).ready(function(){
		$('.team-modal-button').each(function(){
			var $this = $(this);
			var id = $this.attr('data-modal-id');
			$this.click(function(e){
				$('.team-modal-overlay').addClass('show');
				$('body').addClass('disable-scroll');
				$('#team-modal-' + id).addClass('show');
			});
		});

		$('p.modal-close').click(function(){
			$('.team-modal-overlay.show').removeClass('show');
			$('.team-member-modal.show').removeClass('show');
			$('body').removeClass('disable-scroll');
		});

	});
})(jQuery); // Fully reference jQuery after this point.